import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';

const getStyle = (style) => {
  return _.assign({
    padding: 3,
    fontSize: 12,
    color: 'white',
    backgroundColor: 'green',
    textTransform: 'uppercase',
  }, style);
};

const styles = theme => ({
  // root: {
  //   display: 'flex',
  //   justifyContent: 'center',
  //   flexWrap: 'wrap',
  // },
  chip: {
    margin: theme.spacing.unit,
    // backgroundColor: 'green',
    // color: 'white',
    // textTransform: 'uppercase',
  },
});

class Status extends Component {
  render() {
    const { containerStyle, label } = this.props;
    return (
        <span style={getStyle(containerStyle)}>{label}</span>
    );
  }
}

Status.propTypes = {
  label: PropTypes.string.isRequired,
  containerStyle: PropTypes.object,
}

export default withStyles(styles)(Status);



// WEBPACK FOOTER //
// ./src/components/Common/Status/index.js